import { useContext } from 'react'
import { BillingContext } from './BillingContext'

export function useGetBilling() {
  const context = useContext(BillingContext)
  if (!context) throw new Error('useGetBilling must be used within BillingProvider')
  return context
}
